import { gql } from "lib/apolloClient";
import { uiElementFragments } from "./HomePageFragments";

export const getUIElementsQuery = gql`
  query getUIElements($filters: UIElementFilters) {
    platform {
      uiElements(filters: $filters) {
        ...uiElementCard
      }
    }
  }
  ${uiElementFragments.uiElementCard}
`;
